// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <wt-line-chart id=\"{{'alarmsEvolution' + vm.item.guid}}\" chart-data=\"vm.data\" series=\"vm.series\" options=\"vm.options\" ratio=\"vm.ratio\" zoom-control=\"vm.item\"> </wt-line-chart> </div>";
// Exports
module.exports = code;